import Vue from 'vue';

Vue.filter('shortName', input => !input ? input : input.split('-')[0].trim());
